import angular from 'angular';
import uiRouter from 'angular-ui-router';
import filterSelectComponent from './filterSelect.component';

let filterSelectModule = angular.module('filterSelect', [
  uiRouter
])

.component('filterSelect', filterSelectComponent)

.name;

export default filterSelectModule;
